import { useState, useEffect } from 'react';

const GenericCountdownTimer = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Exit the useEffect when count reaches 0
    if (count === 0) {
      return;
    }

    // Set up the interval to decrement count every second
    const intervalId = setInterval(() => {
      setCount(prevCount => prevCount - 1);
    }, 1000);

    // Clean up the interval when the component unmounts or count reaches 0
    return () => clearInterval(intervalId);
  }, [count]);

  return { count, setCount };
};

export default GenericCountdownTimer;
